<template>
	<div class="container">
		<header>
			<div class="logo-wrapper desktop">
				<a href="/">
					<img src="@/assets/images/logo.svg" alt="Magazyn Pismo"/>
				</a>
			</div>
		</header>

		<div class="password-form c-bg-white ">

			<transition name="fade" mode="out-in">
				<template v-if="changeSuccess">
					<div class="c-gray t-center">
						<p>{{ $content.new_password.success }}</p>
						<p>{{ $content.new_password.redirect }}</p>
						<div class="mt-5">
							<span class="loader pink"></span>
						</div>
					</div>
				</template>

				<template v-else>
					<ValidationObserver
						id="changepassform"
						autocomplete="off"
						tag="form"
						v-slot="{ handleSubmit }"
						@submit.prevent
					>
						<h1 class="font-size-h3 font-marat c-gray pb-2 mb-4 bb-1">{{ $content.new_password.title }}</h1>

						<div v-if="passError">
							<p v-if="passError === 'invalidkey'" class="c-gray mb-2">{{ $content.new_password.invalid_key }}</p>
							<p v-if="passError === 'expiredkey'" class="c-gray mb-2">{{ $content.new_password.expired_key }}</p>
							<router-link
								class="btn btn-primary"
								to="/resetuj_haslo/">{{ $content.reset_password.button }}</router-link>
						</div>

						<div v-else>
							<div class="mb-5">
								<p v-if="changeError" class="c-pink mt-2">{{ $content.new_password.error }}</p>
								<p v-else class="c-gray">{{ $content.new_password.desc }}</p>
							</div>

							<div class="mb-3">
								<label
									for="pass1"
									class="label">{{ $content.new_password.password }}:</label>
								<ValidationProvider
									autocomplete="off"
									mode="lazy"
									rules="required"
									vid="password"
									tag="div"
									v-slot="{ errors }">
									<input
										id="pass1"
										name="pass1"
										type="password"
										class="form-control"
										v-model="newPassword">
									<p class="form-error">{{ errors[0] }}</p>
								</ValidationProvider>
							</div>

							<div class="mb-3">
								<label
									for="pass2"
									class="label">{{ $content.new_password.confirm }}:</label>
								<ValidationProvider
									autocomplete="off"
									mode="lazy"
									rules="required|confirmed:password"
									tag="div"
									v-slot="{ errors }">
									<input
										id="pass2"
										name="pass2"
										type="password"
										class="form-control"
										v-model="newPasswordConfirm">
									<p class="form-error">{{ errors[0] }}</p>
								</ValidationProvider>
							</div>

							<button
								@click="handleSubmit(changePassword)"
								:disabled="changeError"
								type="submit"
								class="btn btn-primary btn-max mt-4">
								<span class="loader" v-if="changeInProgress"></span>
								<span v-else>{{ $content.new_password.button }}</span>
							</button>
						</div>

					</ValidationObserver>
				</template>
			</transition>
		</div>
	</div>
</template>

<script>
	import { ValidationProvider, ValidationObserver } from 'vee-validate';

	export default {
		name: 'ChangePasswordForm',
		components: {
			ValidationProvider,
			ValidationObserver
		},
		data() {
			return {
				newPassword: '',
				newPasswordConfirm: '',
				changeInProgress: false,
				changeSuccess: false,
				changeError: false,
				errorMessage: ''
			}
		},
		computed: {
			passError() {
				if (this.$route.query.pass_err) {
					return this.$route.query.pass_err
				} else {
					return false
				}
			}
		},
		methods: {
			changePassword() {
				const URL = 'https://magazynpismo.pl/wp-admin/admin-ajax.php?action=check_password_reset';
				const formData = new FormData();

				this.changeInProgress = true;
				formData.append('pass1', this.newPassword);
				formData.append('pass2', this.newPasswordConfirm);

				this.$http.post(URL, formData)
					.then(res => {
						if (res.data.status === 'success') {
							this.changeSuccess = true;
							this.$store.dispatch('signIn');
							setTimeout( () => {
								this.$router.push({ name: 'prenumerata' })
							}, 3000)
						}
						else if (res.data.status === 'error') {
							this.changeError = 'custom';
							this.errorMessage = res.data.message;
						}
						this.changeInProgress = false;
					})
					.catch(err => {
						this.changeInProgress = false;
						this.changeError = true;
					});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.logo-wrapper {
		padding: 0 40px;
		overflow: hidden;
		max-width: 320px;
		margin: 30px auto 60px;

		img {
			width: 100%;
		}
	}
</style>
